import EventManager from "../../store/sqftEventManager";
import {renderMeasurementsAroundSnappedShapes, renderSlabRightPart, renderSlabWorkspace} from "./sqftSlabDraw";
import workspace from "../workspace";
import SlabAdditionalShapes from "./slabAdditionalShapes";
import sqftSlabManager from "../../store/sqftSlabManager";
import StaticImage from "../workspace/image/StaticImage";
import workspaceZoom from "../workspaceZoom";
import sqftShape from "../shapes/sqftShape";
import {getClosestHigherNumber} from "../../../../helpers/sqftHelper";
import store from "../../../../../../store";

const SlabWorkspace = function() {
  this.eventManager = EventManager;
  this.objectName = {name: 'SlabWorkspace'};
  this.leftImagePos = {
    x: 0,
    y: 0,
  };
  this.state = {
    inEnabled: false,
    mouseDown: false,
    mouseDownPosition: null,
    isCenterButtonRightPartHovered: false,
    isCenterButtonLeftPartHovered: false,
    rightPartZoomedShapeId: 1,
    leftPartZoomedShapeId: 1,
    isSlabPlaceHolderPresent: false,
  }
  this.pos = {
    x: 0,
    y: 0,
  };
  this.slabAdditionalShapes = new SlabAdditionalShapes();
  this.measurementPoints = [];
  this.shapeOffset = null;
  this.centerButtonRightPart = null;
  this.centerButtonLeftPart = null;

  this.getOffset = function() {
    return this.getCenter()
  };

  this.getPos = () => {
    return this.pos
  };

  this.setPos = function(pos) {
    this.pos = {...pos}
  };

  this.getCenter = function() {
    return this.pos
  };

  this.setEnabled = (val) => {
    this.state.inEnabled = val
  };

  this.setSlabPlaceHolderPresent = (val) => {
    this.state.isSlabPlaceHolderPresent = val
  };

  this.getRightPartWidth = () => {
    return workspace.getCanvas().width / 2
  };

  this.getShapeOffset = () => {
    return this.shapeOffset
  };

  this.init = () => {
    this.initRightPart();
    this.initLeftPart();
  }

  this.initRightPart = () => {
    this.centerButtonRightPart = new StaticImage(
      'eyeball',
      this.eventManager.getCtx().canvas.width - 40 - sqftSlabManager.centerButton.width,
      30,
      sqftSlabManager.centerButton.width,
      sqftSlabManager.centerButton.height,
      false,
      true,
      this.beforeRenderCenterButtonRightPart.bind(this)
    );
    this.centerButtonLeftPart = new StaticImage(
      'eyeball',
      this.eventManager.getCtx().canvas.width / 2 - 40 - sqftSlabManager.centerButton.width,
      30,
      sqftSlabManager.centerButton.width,
      sqftSlabManager.centerButton.height,
      false,
      true,
      this.beforeRenderCenterButtonLeftPart.bind(this)
    );
    this.initSlabWorkspaceEvents();
  }

  this.initLeftPart = () => {
    this.eventManager.addEvent(
      this.eventManager.events.RENDER,
      this.renderSlabLeftPartWrapper,
      this.objectName,
      this.eventManager.priorities.SEGMENT_MEASUREMENTS
    );
  }

  this.initSlabWorkspaceEvents = function() {
    this.eventManager.addEvent(
      this.eventManager.events.MOUSE_MOVE,
      this.onMouseMove,
      this.objectName,
      this.eventManager.priorities.SLAB_RIGHT_PART_WORKSPACE
    );
    this.eventManager.addEvent(
      this.eventManager.events.MOUSE_DOWN,
      this.onMouseDown,
      this.objectName,
      EventManager.priorities.SLAB_RIGHT_PART_WORKSPACE
    );
    this.eventManager.addEvent(
      this.eventManager.events.MOUSE_UP,
      this.onMouseUp,
      this.objectName,
      EventManager.priorities.SLAB_RIGHT_PART_WORKSPACE
    );
    this.eventManager.addEvent(
      this.eventManager.events.WHEEL,
      this.onWheel,
      this.objectName,
      this.eventManager.priorities.SLAB_RIGHT_PART_WORKSPACE
    );
    this.eventManager.addEvent(
      this.eventManager.events.RENDER,
      renderSlabWorkspace,
      this.objectName,
      this.eventManager.priorities.SLAB_RIGHT_PART_WORKSPACE
    );
    this.eventManager.addEvent(
      this.eventManager.events.RENDER,
      this.renderSlabRightPartWrapper,
      this.objectName,
      this.eventManager.priorities.SLAB_RIGHT_PART_CONTENT
    );
    this.eventManager.addEvent(
      this.eventManager.events.RENDER,
      this.centerButtonRightPart.render,
      this.objectName,
      this.eventManager.priorities.SLAB_RIGHT_PART_CONTENT
    );
    this.eventManager.addEvent(
      this.eventManager.events.RENDER,
      this.centerButtonLeftPart.render,
      this.objectName,
      this.eventManager.priorities.SLAB_RIGHT_PART_CONTENT
    );
  };

  this.disableSlabImages = () => {
    this.eventManager.removeEvent(this.objectName);
  };

  this.deregisterEvents = () => {
    this.eventManager.removeEvent(this.objectName);
  };

  this.onMouseDown = (mousePos, e) => {
    void e;
    if (this.state.isCenterButtonLeftPartHovered) {
      this.eyeballButtonLeftPartClick();
    }
    if (!this.isOverRightPart(mousePos)) {
      return false;
    }
    if (this.state.isCenterButtonRightPartHovered) {
      this.eyeballButtonRightPartClick();
    }
    this.eventManager.stealCursor(true, true);
    this.state.mouseDown = true;
    this.state.mouseDownPosition = mousePos;
    this.eventManager.setCursor('grabbing', this, false);

    return true;
  };

  this.onMouseUp = (mousePos, e) => {
    if (!this.isOverRightPart(mousePos)) {
      return false;
    }
    this.state.mouseDown = false;
    this.state.mouseDownPosition = null;

    return this.onMouseMove(mousePos, e);
  }

  this.onMouseMove = (mousePos, e) => {
    if (e.terminate) {
      return false;
    }
    this.state.isCenterButtonLeftPartHovered = this.centerButtonLeftPart.isHovered(mousePos);
    if (!this.isOverRightPart(mousePos)) {
      return false;
    }
    this.state.isCenterButtonRightPartHovered = this.centerButtonRightPart.isHovered(mousePos);
    if (this.state.mouseDown) {
      this.moveSlabWorkspace(mousePos);
    } else {
      this.eventManager.resetCursor(this);
    }
    return true;
  }

  this.onWheel = (mousePos, e) => {
    void mousePos;
    void e;

    return true;
  }
  this.moveSlabWorkspace = (mousePos) => {
    if (!this.isOverRightPart(mousePos)) {
      return false;
    }
    let xDiff = mousePos.x - this.state.mouseDownPosition.x;
    let yDiff = mousePos.y - this.state.mouseDownPosition.y;

    this.pos.x -= xDiff;
    this.state.mouseDownPosition.x = mousePos.x;

    this.pos.y -= yDiff;
    this.state.mouseDownPosition.y = mousePos.y;
  };

  this.beforeRenderCenterButtonRightPart = () => {
    this.centerButtonRightPart.x = this.eventManager.getCtx().canvas.width - 40 - sqftSlabManager.centerButton.width;
  };

  this.beforeRenderCenterButtonLeftPart = () => {
    this.centerButtonLeftPart.x = this.eventManager.getCtx().canvas.width / 2 - 40 - sqftSlabManager.centerButton.width;
  };

  this.eyeballButtonRightPartClick = () => {
    const shapesIds = workspace.getShapeIds();
    const closestHigherNumber = getClosestHigherNumber(this.state.rightPartZoomedShapeId, shapesIds);
    const shape = workspace.getShapeById(closestHigherNumber);

    if (shape instanceof sqftShape) {
      workspaceZoom.zoomToSlabShape(shape, false);
      this.state.rightPartZoomedShapeId = shape.id
    } else {
      this.state.rightPartZoomedShapeId = closestHigherNumber === null ? 0 : closestHigherNumber;
      this.eyeballButtonRightPartClick()
    }
    return false
  };

  this.eyeballButtonLeftPartClick = () => {
    const shapesIds = workspace.getShapeIds();
    const closestHigherNumber = getClosestHigherNumber(this.state.leftPartZoomedShapeId, shapesIds);
    const shape = workspace.getShapeById(closestHigherNumber);

    if (shape instanceof sqftShape) {
      workspaceZoom.zoomToShape(shape, false);
      this.state.leftPartZoomedShapeId = shape.id
    } else {
      this.state.leftPartZoomedShapeId = closestHigherNumber === null ? 0 : closestHigherNumber;
      this.eyeballButtonLeftPartClick()
    }
    return false
  };

  this.isOverRightPart = (mousePos = {x: 0}) => {
    let rpw = this.getRightPartWidth();

    return mousePos.x > rpw
  };

  this.renderSlabRightPartWrapper = (ctx, isFullRender = false) => {
    //if (this.state.setSlabPlaceHolderPresent) {
      return renderSlabRightPart(ctx, isFullRender);
    //}
  };
  this.renderSlabLeftPartWrapper = (ctx) => {
    const reduxState = store.getState()
    let isMeasurementVisibleInSlabMode = reduxState.sqftSlabState.isMeasurementVisibleInSlabMode;
    if (isMeasurementVisibleInSlabMode) {
      renderMeasurementsAroundSnappedShapes(ctx, this.measurementPoints);
    }
  };
};

export default new SlabWorkspace;
